(function() {
  'use strict';

  function RolesController(
    RouterHelper, $rootScope, Profile, Roles, RoleSearch, Security, List, $translate, Utils
  ) {
    var ctrl = this;
    ctrl.options = {
      trackBy: 'doc._id'
    };

    Utils.setPageTitle('Roles');

    ctrl.searchModel = Profile.getListPreferences('roles').current;

    ctrl.list = new List({
      search: RoleSearch.search,
      model: ctrl.searchModel,
      idField: 'doc._id'
    });

    $rootScope.$broadcast('KZCurrentListChange', { list: 'roles', search: ctrl.list.search });

    Roles.findAll({}, {}, { cached: false })
      .then(function(data) {
        ctrl.list.doLoadItems(data);
      });

    ctrl.actions = [
      {
        label: $translate.instant('New role'),
        icon: 'icon-edit',
        route: ['/roles/new'],
        showCondition: Security.hasPermission.bind(this, 'roles.edit'),
        klass: 'btn-success'
      }
    ];

    // Defined here so that I don't have to create a special slot that does nothing
    ctrl.options.actionButtons = function(item) {
      return [
        {
          label: $translate.instant('Edit'),
          icon: 'icon-edit',
          route: ['/roles/edit', item.doc._id],
          showCondition: Security.hasPermission.bind(this, 'roles.edit'),
          klass: 'text-info'
        },
        {
          label: $translate.instant('View'),
          icon: 'icon-edit',
          route: ['/roles/edit', item.doc._id],
          showCondition: function() {
            return Security.hasPermission('roles.edit')
              .then(function(has) {
                return !has;
              })
              .catch(function() {
                return true;
              });
          },
          klass: 'text-info'
        }
      ];
    };

    ctrl.options.secondaryActionButtons = function(item) {
      return [
        {
          label: $translate.instant('Duplicate'),
          icon: 'icon-duplicate',
          onClick: function() {
            var duplicateDoc = angular.copy(item.doc);
            delete duplicateDoc._id;
            delete duplicateDoc._rev;
            duplicateDoc.title = 'Copy of ' + item.doc.title;

            RouterHelper.navigate(['/roles/new'],
              { state: { template: duplicateDoc } }
            );
          },
          showCondition: Security.hasPermission.bind(this, 'roles.edit'),
          klass: 'text-info'
        }
      ];
    };
  }

  RolesController.$inject = [
    'RouterHelperService',
    '$rootScope',
    'ProfileService',
    'RolesService',
    'RoleSearch',
    'SecurityService',
    'ListFactory',
    '$translate',
    'UtilsService'
  ];

  angular.module('component.roles')
    .component('rolesList', {
      templateUrl: 'app/components/roles/list.html',
      controller: RolesController,
      controllerAs: 'rolesCtrl'
    });
})();
